import "firebase/firestore";

import "./static/fonts/fonts.css";

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
}
